import EyeIcon from "src/core/assets/images/icons/eye.svg?react";
import { DocumentIconComponent } from "src/core/components/documents/DocumentIcon";
import { Button } from "src/core/components/ui/button";
import { FILE_EXTENSION_GROUPS } from "src/core/constants/general";

export const DocumentCard: React.FC<{
  filename: string;
  document: {
    id: string | undefined;
    name: string;
    code: string;
    expirationDate: string | undefined;
  };
  handlePreview?: (document: { id: string; name: string }) => void;
}> = ({ filename, document, handlePreview }) => {
  const extension = filename.split(".").pop() ?? "";
  const getType = (ext: string): string => {
    for (const [key, extensions] of Object.entries(FILE_EXTENSION_GROUPS)) {
      if (extensions.includes(ext.toLowerCase())) return key;
    }
    return "";
  };

  return (
    <div className="flex items-center w-full max-w-full h-[50px] rounded-lg bg-background-secondary border border-border px-3 min-w-0">
      <div className="shrink-0 mr-3">
        <DocumentIconComponent extension={extension} />
      </div>
      <div className="flex flex-col min-w-0 flex-1">
        <div className="truncate text-sm">{filename}</div>
        <div className="uppercase text-disabled text-xs truncate">{getType(extension)}</div>
      </div>
      {document.id && handlePreview && (
        <div
          role="button"
          className="shrink-0 pr-10 cursor-pointer"
          onClick={(e) => {
            e.preventDefault();
            if (document.id) handlePreview({ id: document.id, name: document.name });
          }}
        >
          <Button variant="action" size="none">
            <EyeIcon />
          </Button>
        </div>
      )}
    </div>
  );
};
